import { h, VNode } from 'preact';

import FeedbackFormRatings from './ratings';
import FeedbackFormContact from './contact';
import FeedbackFormComplete from './complete';
import { useEnv } from '@hooks/useEnv';
import { signal } from '@preact/signals';
import { useRef } from 'preact/hooks';
import useOnClickOutside from '@hooks/useOutside';
import { useScreen } from '@hooks/useScreen';
import { closeWidget } from '@components/organisms/widget/widget';
import { useSendFeedback } from '@api/index';

const MAX_STEPS = 2;

const formStep = signal(0);

export const handleNext = (): number | void => {
  if (MAX_STEPS >= formStep.value + 1) {
    return (formStep.value += 1);
  }
};

export const resetFormStep = (): void => {
  formStep.value = 0;
};

const FeedbackForm = (): VNode => {
  const { useCaptcha } = useEnv();
  const { isMobile } = useScreen();
  const formContainerRef = useRef(null);

  const { isLoading, success, handleFetch } = useSendFeedback();

  useOnClickOutside(formContainerRef, () => {
    if (isMobile) {
      closeWidget();
    }
  });

  let currentStep: VNode = null;

  switch (formStep.value) {
    case 0:
      currentStep = <FeedbackFormRatings useCaptcha={useCaptcha} />;
      break;
    case 1:
      currentStep = <FeedbackFormContact handleSubmit={handleFetch} />;
      break;
    case 2:
      currentStep = <FeedbackFormComplete isLoading={isLoading.value} success={success.value} />;
      break;
  }

  return <div ref={formContainerRef}>{currentStep}</div>;
};

export default FeedbackForm;
